import $ from 'jquery';
import './page.scss';
import Cookies from 'js-cookie';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp, onAuthStateChanged } from '../../js/firebaseConfig';
import { checkAuthAndRedirect } from '../../js/redirect.js';

$(document).ready(function() {
    $('#titleForm').text('Pour accèder au résultat veuillez créer un compte:');
    //GET COOKIE
    const formDataCookie = Cookies.get('formData');
    if (formDataCookie) {
        $('body').addClass('formCompleted')
        const formData = JSON.parse(formDataCookie);
        $('#email').val(formData.email || '');
        $('#company').val(formData.company || '').addClass('valid').css('pointer-events', 'none');
    }
});